import { useTranslation } from 'react-i18next';
import { Image, Linking, Pressable, ScrollView, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { SafeAreaView } from 'react-native-safe-area-context';

import { AppText } from '@/components/ui/app-text';
import { Card } from '@/components/ui/card';
import { ScreenHeader } from '@/components/ui/screen-header';
import { colors, spacing } from '@/theme/tokens';

// Brand mark instead of a placeholder "P" bubble (owner request 2026-07-11).
const POLFINANCE_ICON = require('../../assets/images/polfinance-icon.png');

/**
 * "O Polfinance" — who stands behind the app. A client who got the app from
 * an agent (or found it in the store) should be able to check the company is
 * real and how to reach it, without leaving the app.
 */
export default function AboutScreen() {
  const { t } = useTranslation();

  const CONTACTS = [
    { icon: 'globe-outline', label: 'polfinance.pl', url: 'https://polfinance.pl' },
    { icon: 'mail-outline', label: 'kontakt@polfinance.pl', url: 'mailto:kontakt@polfinance.pl' },
  ] as const;

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: colors.background }} edges={['top', 'bottom']}>
      <ScrollView contentContainerStyle={{ padding: spacing.screen, gap: spacing.md, paddingBottom: spacing.xl }}>
        <ScreenHeader title={t('about.title')} />

        <View style={{ alignItems: 'center', gap: spacing.sm }}>
          <Image
            source={POLFINANCE_ICON}
            style={{ width: 88, height: 88 }}
            resizeMode="contain"
          />
          <AppText variant="headlineMd">Polfinance</AppText>
          <AppText variant="bodyMd" style={{ textAlign: 'center' }}>
            {t('about.tagline')}
          </AppText>
        </View>

        <Card style={{ gap: spacing.sm }}>
          <AppText variant="bodyLg">{t('about.body1')}</AppText>
          <AppText variant="bodyLg">{t('about.body2')}</AppText>
        </Card>

        <Card style={{ padding: 0 }}>
          {CONTACTS.map((c, idx) => (
            <Pressable
              key={c.label}
              accessibilityRole="link"
              onPress={() => void Linking.openURL(c.url)}
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                gap: spacing.sm,
                padding: spacing.md,
                minHeight: 56,
                borderTopWidth: idx === 0 ? 0 : 1,
                borderTopColor: colors.divider,
              }}
            >
              <Ionicons name={c.icon} size={22} color={colors.primary} />
              <AppText variant="bodyLg" color={colors.primary} style={{ flex: 1 }}>
                {c.label}
              </AppText>
              <Ionicons name="open-outline" size={18} color={colors.outlineVariant} />
            </Pressable>
          ))}
        </Card>
      </ScrollView>
    </SafeAreaView>
  );
}
